import SlidingCardGridComponent from "./sliding-card-grid-component";
import SlidingCardGridConfig from "./sliding-card-grid-config";
import SlidingCardGridAdvancedConfig from "./sliding-card-grid-advanced-config";

export default {
  SlidingCardGridComponent,
  SlidingCardGridConfig,
  SlidingCardGridAdvancedConfig
};
